var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "confirm-email-content" }, [
    _vm.isProcessing
      ? _c(
          "div",
          [_c("v-progress-circular", { attrs: { indeterminate: "" } })],
          1
        )
      : _c("div", [
          _vm.isEmailConfirmed
            ? _c("div", [
                _c(
                  "p",
                  { staticClass: "generic-icon-note" },
                  [
                    _c(
                      "v-icon",
                      { staticClass: "mr-1", attrs: { color: "success" } },
                      [_vm._v("check_circle")]
                    ),
                    _c("span", [
                      _vm._v("Your email has been confirmed successfully!")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.$t("BetSlipPage.msg.LogIn")))])
              ])
            : _c("div", [
                _c(
                  "p",
                  { staticClass: "generic-icon-note" },
                  [
                    _c(
                      "v-icon",
                      { staticClass: "mr-1", attrs: { color: "error" } },
                      [_vm._v("error")]
                    ),
                    _c("span", [
                      _vm._v("There was an error with your email confirmation.")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.errorMessage))])
              ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa780204", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa780204","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/IntegratedWallet/ConfirmEmailByTempSession.vue
// module id = null
// module chunks = 